import React, { Component } from "react";
import fetchProductImage from "../graphql/queries/fetchProductImage.graphql";
/*
id
*/

class ProductImage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			image: null,
			title: "",
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData = async () => {
		// console.log("prep", this.props.id);
		const { data, errors, extensions } = await this.props.client.request(fetchProductImage.loc.source.body, {
			variables: {
				id: this.props.id,
			},
		});

		if (errors) {
			console.error("error!", JSON.stringify(errors, null, 2));
			return;
		}
		// console.log("result1!", JSON.stringify(data, null, 2), JSON.stringify(extensions, null, 2));

		this.setState({ image: data.product.images.nodes[0], title: data.product.title });
	};

	render() {
		if (this.state.image == null || this.state.title == "") return null;

		return <img src={this.state.image.url} alt={`${this.state.title} product shot`} />;
	}
}

export default ProductImage;
